import React from "react";
import "./aboutUs.css";
import { Fade } from "react-awesome-reveal";

export default function AboutUs() {
  return (
    <section className="aboutUs" id="aboutUs">
      <div className="aboutWho"></div>
      <div className="aboutOur">
        <Fade triggerOnce={true} direction="up" duration="1500" delay={1}>
          <div className="whyUs">
            <div className="contentHead">
              <i className="bi bi-person-check-fill"></i>
              <h5>Why Us?</h5>
            </div>
            <p>
              Our products are designed to be durable, easy to install and
              maintain, and optimized for maximum energy production that work
              for decades under extreme weather conditions.
            </p>
          </div>
        </Fade>
        <Fade triggerOnce={true} direction="up" duration="1000" delay={2}>
          <div className="ourVision">
            <div className="contentHead">
              <i className="bi bi-hand-thumbs-up-fill"></i>
              <h5>Our Vision</h5>
            </div>
            <p>
              “Our vision is to be the leading PV panel cleaning service by
              helping every solar owner maximize their energy production. We aim
              to empower a sustainable future, one clean panel at a time"
            </p>
          </div>
        </Fade>
        <Fade triggerOnce={true} direction="up" duration="1500" delay={3}>
          <div className="ourMission">
            <div className="contentHead">
              <i className="bi bi-rocket-fill"></i>
              <h5>Our Mission</h5>
            </div>
            <p>
              "Our mission is to provide exceptional and reliable PV panel
              cleaning services that enhance the efficiency and extend the
              lifespan of solar installations."
            </p>
          </div>
        </Fade>
      </div>
      <div className="facts">
        <img src="./images/LeftLines.png" alt="leftLines"></img>
        <img src="./images/RightLines.png" alt="rightLines"></img>
        <div className="factsContent">
          <div className="factsBox">
            <h1>4000+</h1>
            <span>Project Sites</span>
          </div>
          <div className="factsBox">
            <h1>50+</h1>
            <span>Coverage cities </span>
          </div>
          <div className="factsBox">
            <h1>98%</h1>
            <span>Satisfaction Rate</span>
          </div>
        </div>
      </div>
    </section>
  );
}
